export const imageBaseUrl = '/atoms/baseModels'
import { NextRouter } from 'next/router'
import { I18NText, Model, ShoesModel } from 'src/types'
export const glovePriceTaxIncluded = 74800 // 税込
export const mittPriceTaxIncluded = 77000 // 税込
export const softGloveBasePrice = 58300 // 税込
export const softMittBasePrice = 60500 // 税込

export const atomsYouthBaseModel = (t: I18NText, kinds: 'glove' | 'mitt'): Model[] => {
  const youthGloveModels = kinds === 'glove' ? youthGloveBaseModels(t) : []
  const youthMittModels = kinds === 'mitt' ? youthMittBaseModels(t) : []

  return [...youthGloveModels, ...youthMittModels]
}

export const atomsBaseModel = (t: I18NText, router: NextRouter): Model[] => {
  const urlParams = router.asPath.split('/')
  const seriesIndex = urlParams.length - 2
  const series = urlParams[seriesIndex] as 'japan' | 'us' | 'korea' | 'youth'

  const jaModels = series === 'japan' ? atomsJaBaseModels(t) : []
  const youthGloveModels = series === 'youth' && urlParams[urlParams.length - 1] === 'glove' ? youthGloveBaseModels(t) : []
  const youthMittModels = series === 'youth' && urlParams[urlParams.length - 1] === 'mitt' ? youthMittBaseModels(t) : []

  return [...jaModels, ...youthGloveModels, ...youthMittModels]
}

const imageWidth = 240

// 品番定数 - 大文字スネークケース形式

export const PRO46_AKG_1_PRODUCT_NUMBER = '2024-PRO46(AKG-1型)'
export const AKG_1_PRODUCT_NUMBER = 'AKG-1'
export const AKG_4_PRODUCT_NUMBER = 'AKG-4'
export const AKG_5_PRODUCT_NUMBER = 'AKG-5'
export const AKG_6_PRODUCT_NUMBER = 'AKG-6'
export const AKG_7_PRODUCT_NUMBER = 'AKG-7'
export const AKG_11_PRODUCT_NUMBER = 'AKG-11'
export const AKG_12_PRODUCT_NUMBER = 'AKG-12'
export const AKG_13_PRODUCT_NUMBER = 'AKG-13'
export const AKG_14_PRODUCT_NUMBER = 'AKG-14'
export const AKG_15_PRODUCT_NUMBER = 'AKG-15'
export const AKG_16_PRODUCT_NUMBER = 'AKG-16'

export const AKG_21_PRODUCT_NUMBER = 'AKG-21'
export const AKG_27_PRODUCT_NUMBER = 'AKG-27'
export const AKG_GT07_PRODUCT_NUMBER = 'AKG-GT07'
export const AKG_JS2_PRODUCT_NUMBER = 'AKG-JS2'
export const AKG_JS5_PRODUCT_NUMBER = 'AKG-JS5'
export const AKG_JS4_PLUS_PRODUCT_NUMBER = 'AKG-JS4+'

export const APL_UR2_PRODUCT_NUMBER = 'APL-UR2'
export const APL_UR4_PRODUCT_NUMBER = 'APL-UR4'

export const APL_UR002_PLUS_PRODUCT_NUMBER = 'APL-UR002+'
export const APL_UR003_PLUS_PRODUCT_NUMBER = 'APL-UR003+'
export const APL_UR004_PLUS_PRODUCT_NUMBER = 'APL-UR004+'
export const APL_UR005_PLUS_PRODUCT_NUMBER = 'APL-UR005+'
export const APL_UR006_PLUS_PRODUCT_NUMBER = 'APL-UR006+'
export const APL_UR007_PLUS_PRODUCT_NUMBER = 'APL-UR007+'
export const APL_UR008_PLUS_PRODUCT_NUMBER = 'APL-UR008+'
export const APL_UR015_PLUS_PRODUCT_NUMBER = 'APL-UR015+'
export const APL_UR026_PLUS_PRODUCT_NUMBER = 'APL-UR026+'
export const APL_UR066_PLUS_PRODUCT_NUMBER = 'APL-UR066+'

export const APL_NE102_PRODUCT_NUMBER = 'APL-NE102'
export const APL_NE021_PRODUCT_NUMBER = 'APL-NE021'
export const APL_NE026_PRODUCT_NUMBER = 'APL-NE026'
export const APL_NE066_PRODUCT_NUMBER = 'APL-NE066'
export const APL_NE702_PRODUCT_NUMBER = 'APL-NE702'

export const AGL_NE001_AKG_1_PRODUCT_NUMBER = 'AGL-NE001(AKG-1)'
export const AGL_105_PRODUCT_NUMBER = 'AGL-105'
export const AGL_501_PRODUCT_NUMBER = 'AGL-501'
export const AGL_503_PRODUCT_NUMBER = 'AGL-503'
export const AGL_601_PRODUCT_NUMBER = 'AGL-601'
export const AGL_603_PRODUCT_NUMBER = 'AGL-603'

export const AGL_NE105_PRODUCT_NUMBER = 'AGL-NE105'
export const AGL_NE011_AKG_21_PRODUCT_NUMBER = 'AGL-NE011(AKG-21)'
export const AGL_NE501_PRODUCT_NUMBER = 'AGL-NE501'
export const AGL_NE102_AKG_5_PRODUCT_NUMBER = 'AGL-NE102(AKG-5)'
export const AGL_NE801_PRODUCT_NUMBER = 'AGL-NE801'
export const AGL_NE002_AKG_GT22_PRODUCT_NUMBER = 'AGL-NE002(AKG-GT22)'
export const AGL_NE003_AKG_GT33_PRODUCT_NUMBER = 'AGL-NE003(AKG-GT33)'
export const AGL_NE008_AKG_GT07_PRODUCT_NUMBER = 'AGL-NE008(AKG-GT07)'

export const AGL_702_PRODUCT_NUMBER = 'AGL-702'
export const AGL_801_PRODUCT_NUMBER = 'AGL-801'
export const AGL_1001_PRODUCT_NUMBER = 'AGL-1001'
export const AGL_1004_PRODUCT_NUMBER = 'AGL-1004'
export const AGL_1006_PRODUCT_NUMBER = 'AGL-1006'
export const AGL_2001_PRODUCT_NUMBER = 'AGL-2001'
export const AGL_3001_PRODUCT_NUMBER = 'AGL-3001'

export const ATR_006_PRODUCT_NUMBER = 'ATR-006'

export const SHOES_1_PRODUCT_NUMBER = 'shoes-1'

export const REINFORCEMENT_LACE_MODEL = [
  AKG_JS4_PLUS_PRODUCT_NUMBER,
  AKG_JS5_PRODUCT_NUMBER,
  AKG_4_PRODUCT_NUMBER,
  AKG_5_PRODUCT_NUMBER,
  AKG_6_PRODUCT_NUMBER,
  AKG_14_PRODUCT_NUMBER,
  AKG_15_PRODUCT_NUMBER,
  AKG_16_PRODUCT_NUMBER,
  APL_UR2_PRODUCT_NUMBER,
  APL_UR4_PRODUCT_NUMBER,
  APL_UR026_PLUS_PRODUCT_NUMBER,
  APL_UR004_PLUS_PRODUCT_NUMBER,
  APL_UR005_PLUS_PRODUCT_NUMBER,
  APL_UR006_PLUS_PRODUCT_NUMBER,
  APL_UR007_PLUS_PRODUCT_NUMBER,
  APL_UR015_PLUS_PRODUCT_NUMBER,
  AGL_501_PRODUCT_NUMBER,
  AGL_503_PRODUCT_NUMBER,
  AGL_601_PRODUCT_NUMBER,
  AGL_603_PRODUCT_NUMBER,
  ATR_006_PRODUCT_NUMBER
]

export const SEQUENTIAL_ROLL_GLOVE_PRODUCT_NUMBERS = [AGL_NE001_AKG_1_PRODUCT_NUMBER, AGL_NE011_AKG_21_PRODUCT_NUMBER]
export const atomsJaBaseModels = (t: I18NText): Model[] => {
  const AGL_NE105: Model = {
    productNumber: AGL_NE105_PRODUCT_NUMBER,
    subProductNumber: '',
    position: 'pitcher',
    imageUrl: `${imageBaseUrl}/agl-ne105.jpg`,
    dominantArm: 'both',
    size: t.AGL_NE105.size, // サイズ
    description: t.AGL_NE105.description,
    webParts: 'w26',
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    softPrice: softGloveBasePrice,
    price: t.BASE_PRICE_GLOVE,
    brand: 'atoms',
    imageWidth,
    imageHeight: 150
  }

  return [
    {
      productNumber: AGL_NE001_AKG_1_PRODUCT_NUMBER,
      position: 'pitcher',
      imageUrl: `${imageBaseUrl}/agl-ne001.jpg`,
      dominantArm: 'both',
      size: t.AGL_NE001.size,
      webParts: 'w37',
      description: t.AGL_NE001.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: AGL_NE011_AKG_21_PRODUCT_NUMBER,
      position: 'pitcher',
      imageUrl: `${imageBaseUrl}/agl-ne011.jpg`,
      dominantArm: 'both',
      size: t.AGL_NE011.size,
      webParts: 'w1',
      description: t.AGL_NE011.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      ...AGL_NE105
    },
    {
      productNumber: PRO46_AKG_1_PRODUCT_NUMBER,
      position: 'pitcher',
      imageUrl: `${imageBaseUrl}/akg-pro46.jpg`,
      dominantArm: 'both',
      size: t.AKG_PRO46.size,
      webParts: 'w1',
      description: t.AKG_PRO46.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 140
    },
    {
      productNumber: AKG_11_PRODUCT_NUMBER,
      position: 'pitcher',
      imageUrl: `${imageBaseUrl}/akg-11.jpg`,
      dominantArm: 'both',
      size: t.AKG_11.size,
      webParts: 'w5',
      description: t.AKG_11.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 145
    },
    // 逆巻き↓
    {
      productNumber: APL_NE021_PRODUCT_NUMBER,
      subProductNumber: '',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ne021.jpg`,
      dominantArm: 'right',
      webParts: 'w31',
      size: t.APL_NE021.size, // サイズ
      description: t.APL_NE021.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    // 順巻き↓
    {
      productNumber: APL_NE026_PRODUCT_NUMBER,
      subProductNumber: '',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ne026.jpg`,
      dominantArm: 'right',
      webParts: 'w11',
      size: t.APL_NE026.size, // サイズ
      description: t.APL_NE026.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: APL_NE066_PRODUCT_NUMBER,
      subProductNumber: '',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ne066.jpg`,
      dominantArm: 'right',
      webParts: 'w32',
      size: t.APL_NE066.size, // サイズ
      description: t.APL_NE066.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: APL_NE102_PRODUCT_NUMBER,
      subProductNumber: '',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ne102.jpg`,
      dominantArm: 'both',
      webParts: 'w26',
      size: t.APL_NE102.size, // サイズ
      description: t.APL_NE102.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      ...AGL_NE105,
      position: 'infielder'
    },
    {
      productNumber: AGL_NE501_PRODUCT_NUMBER,
      subProductNumber: '',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/agl-ne501.jpg`,
      dominantArm: 'right',
      size: t.AGL_NE501.size, // サイズ
      webParts: 'w11',
      description: t.AGL_NE501.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: AGL_NE102_AKG_5_PRODUCT_NUMBER,
      subProductNumber: '',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/agl-ne102.jpg`,
      dominantArm: 'right',
      webParts: 'w10',
      size: t.AGL_NE102.size, // サイズ
      description: t.AGL_NE102.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: APL_UR066_PLUS_PRODUCT_NUMBER,
      subProductNumber: '2024-PR02牧秀吾選手型',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ur066+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR066_PLUS.size, // サイズ
      webParts: 'w32',
      description: t.APL_UR066_PLUS.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },

    {
      productNumber: APL_UR006_PLUS_PRODUCT_NUMBER,
      subProductNumber: '2024-PRO39プロ選手型',
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ur006+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR006_PLUS.size, // サイズ
      webParts: 'w10',
      description: t.APL_UR006_PLUS.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 145
    },
    {
      productNumber: APL_UR026_PLUS_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ur026+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR026_PLUS.size,
      webParts: 'w11',
      description: t.APL_UR026_PLUS.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 115
    },
    {
      productNumber: APL_UR004_PLUS_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ur004+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR004_PLUS.size, // サイズ
      webParts: 'w11',
      description: t.APL_UR004_PLUS.description,
      series: '',
      isFingerCrotch: true,
      isUBack: true,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 115
    },
    {
      productNumber: APL_UR005_PLUS_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ur005+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR005_PLUS.size, // サイズ
      webParts: 'w6',
      description: t.APL_UR005_PLUS.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 120
    },
    {
      productNumber: AKG_JS4_PLUS_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/akg-js4+.jpg`,
      dominantArm: 'both',
      size: t.AKG_JS4_PLUS.size,
      webParts: 'w29',
      description: t.AKG_JS4_PLUS.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 120
    },
    {
      productNumber: AKG_JS5_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/akg-js5.jpg`,
      dominantArm: 'both',
      size: t.AKG_JS5.size,
      webParts: 'w10',
      description: t.AKG_JS5.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 115
    },
    {
      productNumber: AKG_4_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/akg-4.jpg`,
      dominantArm: 'both',
      size: t.AKG_4.size,
      webParts: 'w29',
      description: t.AKG_4.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 140
    },
    {
      productNumber: AKG_5_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/akg-5.jpg`,
      dominantArm: 'both',
      size: t.AKG_5.size,
      webParts: 'w8',
      description: t.AKG_5.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 140
    },
    {
      productNumber: AKG_6_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/akg-6.jpg`,
      dominantArm: 'both',
      size: t.AKG_6.size,
      webParts: 'w10',
      description: t.AKG_6.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 140
    },
    {
      productNumber: AKG_16_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/akg-16.jpg`,
      dominantArm: 'both',
      size: t.AKG_16.size,
      webParts: 'w11',
      description: t.AKG_16.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 140
    },
    {
      productNumber: APL_UR4_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/apl-ur4.jpg`,
      dominantArm: 'both',
      size: t.APL_UR4.size,
      webParts: 'w11',
      description: t.APL_UR4.description,
      series: '',
      isFingerCrotch: true,
      isUBack: true,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 115
    },
    {
      productNumber: AGL_105_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/agl-105.jpg`,
      dominantArm: 'both',
      size: t.AGL_105.size, // サイズ
      webParts: 'w13',
      description: t.AGL_105.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 145
    },
    {
      productNumber: AGL_501_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/agl-501.jpg`,
      dominantArm: 'both',
      size: t.AGL_501.size, // サイズ
      webParts: 'w8',
      description: t.AGL_501.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: APL_NE702_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/apl-ne702.jpg`,
      dominantArm: 'both',
      webParts: 'w19',
      size: t.APL_NE702.size, // サイズ
      description: t.APL_NE702.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 160
    },
    {
      productNumber: AGL_NE801_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/agl-ne801.jpg`,
      dominantArm: 'both',
      size: t.AGL_NE801.size, // サイズ
      webParts: 'w20',
      description: t.AGL_NE801.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 160
    },
    {
      productNumber: AGL_NE008_AKG_GT07_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/agl-ne008.jpg`,
      dominantArm: 'both',
      size: t.AGL_NE008.size, // サイズ
      webParts: 'w23',
      description: t.AGL_NE008.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 160
    },
    {
      ...AGL_NE105,
      position: 'outfielder'
    },
    {
      productNumber: AKG_7_PRODUCT_NUMBER,
      subProductNumber: '2024-PRO41プロ選手型',
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/akg-7.jpg`,
      dominantArm: 'both',
      size: t.AKG_7.size, // サイズ
      webParts: 'w14',
      description: t.AKG_7.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: AKG_GT07_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/akg-gt07.jpg`,
      dominantArm: 'both',
      size: t.AKG_GT07.size, // サイズ
      webParts: 'w33',
      description: t.AKG_GT07.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 150
    },
    {
      productNumber: AKG_27_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/akg-27.jpg`,
      dominantArm: 'both',
      size: t.AKG_27.size, // サイズ
      webParts: 'w19',
      description: t.AKG_27.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 155
    },
    {
      productNumber: AGL_801_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/agl-801.jpg`,
      dominantArm: 'both',
      size: t.AGL_801.size, // サイズ
      webParts: 'w20',
      description: t.AGL_801.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 165
    },
    {
      productNumber: APL_UR007_PLUS_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/apl-ur007+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR007_PLUS.size, // サイズ
      webParts: 'w23',
      description: t.APL_UR007_PLUS.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 115
    },
    {
      productNumber: AGL_702_PRODUCT_NUMBER,
      position: 'outfielder',
      imageUrl: `${imageBaseUrl}/agl-702.jpg`,
      dominantArm: 'both',
      size: t.APL_UR007_PLUS.size, // サイズ
      webParts: 'w23',
      description: t.APL_UR007_PLUS.description,
      series: '',
      isFingerCrotch: true,
      isUBack: false,
      softPrice: softGloveBasePrice,
      price: t.BASE_PRICE_GLOVE,
      brand: 'atoms',
      imageWidth,
      imageHeight: 125
    },

    {
      productNumber: AGL_NE003_AKG_GT33_PRODUCT_NUMBER,
      position: 'first',
      imageUrl: `${imageBaseUrl}/agl-ne003.jpg`,
      dominantArm: 'both',
      webParts: '',
      size: t.AGL_NE003.size, // サイズ
      description: t.AGL_NE003.description,
      series: 'domesticLine',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 160
    },
    {
      productNumber: AKG_13_PRODUCT_NUMBER,
      position: 'first',
      imageUrl: `${imageBaseUrl}/akg-13.jpg`,
      dominantArm: 'both',
      size: t.AKG_13.size, // サイズ
      webParts: '',
      description: t.AKG_13.description,
      series: 'domesticLine',
      isFingerCrotch: false,
      isUBack: false,
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 160
    },
    {
      productNumber: APL_UR003_PLUS_PRODUCT_NUMBER,
      position: 'first',
      imageUrl: `${imageBaseUrl}/apl-ur003+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR003_PLUS.size, // サイズ
      webParts: '',
      description: t.APL_UR003_PLUS.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'belt',
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 110
    },
    {
      productNumber: AGL_NE002_AKG_GT22_PRODUCT_NUMBER,
      position: 'catcher',
      imageUrl: `${imageBaseUrl}/agl-ne002.jpg`,
      dominantArm: 'right',
      size: t.AGL_NE002.size, // サイズ
      webParts: '',
      description: t.AGL_NE002.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'beltBackStyleCatcher',
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 145
    },
    {
      productNumber: AKG_12_PRODUCT_NUMBER,
      position: 'catcher',
      imageUrl: `${imageBaseUrl}/akg-12.jpg`,
      dominantArm: 'both',
      size: t.AKG_12.size, // サイズ
      webParts: '',
      description: t.AKG_12.description,
      series: 'domesticLine',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'regularBackStyleCatcher',
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 140
    },
    {
      productNumber: AKG_JS2_PRODUCT_NUMBER,
      position: 'catcher',
      imageUrl: `${imageBaseUrl}/akg-js2.jpg`,
      dominantArm: 'both',
      size: t.AKG_JS2.size, // サイズ
      webParts: '',
      description: t.AKG_JS2.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'regularBackStyleCatcher',
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 130
    },
    {
      productNumber: APL_UR002_PLUS_PRODUCT_NUMBER,
      position: 'catcher',
      imageUrl: `${imageBaseUrl}/apl-ur002+.jpg`,
      dominantArm: 'both',
      size: t.APL_UR002_PLUS.size, // サイズ
      webParts: '',
      description: t.APL_UR002_PLUS.description,
      series: '',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'beltBackStyleCatcher',
      softPrice: softMittBasePrice,
      price: t.BASE_PRICE_MITT,
      brand: 'atoms',
      imageWidth,
      imageHeight: 110
    }
  ]
}

const youthGloveBaseModels = (t: I18NText): Model[] => {
  return [
    {
      productNumber: AGL_1001_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/youth/agl-1001.jpg`,
      dominantArm: 'both',
      size: 27.5,
      webParts: 'w11',
      description: '小学校高学年〜小さめ好みの大人まで使えるモデル',
      series: 'youth',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'beltBackStyle', // グラブ
      price: t.BASE_PRICE_GLOVE,
      softPrice: softGloveBasePrice,
      brand: 'atoms',
      imageWidth,
      imageHeight: 145
    },
    {
      productNumber: AGL_1004_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/youth/agl-1004.jpg`,
      dominantArm: 'both',
      size: 26.5,
      webParts: 'w11',
      description: '小学生向けグラブ。手の小さな中学生からの依頼で考案しました。',
      series: 'youth',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'beltBackStyle', // グラブ
      price: t.BASE_PRICE_GLOVE,
      softPrice: softGloveBasePrice,
      brand: 'atoms',
      imageWidth,
      imageHeight: 155
    },
    {
      productNumber: AGL_1006_PRODUCT_NUMBER,
      position: 'infielder',
      imageUrl: `${imageBaseUrl}/youth/agl-1006.jpg`,
      dominantArm: 'both',
      size: 29.8,
      webParts: 'w17',
      description: '小学校高学年〜小さめ好みの大人まで使えるモデル。',
      series: 'youth',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'beltBackStyle', // グラブ
      price: t.BASE_PRICE_GLOVE,
      softPrice: softGloveBasePrice,
      brand: 'atoms',
      imageWidth,
      imageHeight: 160
    }
  ]
}

const youthMittBaseModels = (t: I18NText): Model[] => {
  return [
    {
      productNumber: AGL_2001_PRODUCT_NUMBER,
      position: 'catcher',
      imageUrl: `${imageBaseUrl}/youth/agl-2001.jpg`,
      dominantArm: 'both',
      size: 30.0,
      webParts: '',
      description: '小学校高学年〜小さめ好みの大人まで使えるモデル。大人の方でトレーニング用・ブルペンミットとしてもご使用いただいています。',
      series: 'youth',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'regularBackStyleCatcher',
      price: t.BASE_PRICE_GLOVE,
      softPrice: softMittBasePrice,
      brand: 'atoms',
      imageWidth,
      imageHeight: 145
    },
    {
      productNumber: AGL_3001_PRODUCT_NUMBER,
      position: 'first',
      imageUrl: `${imageBaseUrl}/youth/agl-3001.jpg`,
      dominantArm: 'both',
      size: 28.5,
      webParts: '',
      description: '小学校高学年〜小さめ好みの大人まで使えるモデル。手の小さな中学生からの依頼で考案しました。',
      series: 'youth',
      isFingerCrotch: false,
      isUBack: false,
      backStyle: 'belt',
      price: t.BASE_PRICE_GLOVE,
      softPrice: softMittBasePrice,
      brand: 'atoms',
      imageWidth,
      imageHeight: 155
    }
  ]
}

export const shoesBaseModels = (): ShoesModel[] => {
  return [
    {
      brand: 'atoms',
      productNumber: SHOES_1_PRODUCT_NUMBER,
      size: 0,
      description: '',
      image: {
        url: `${imageBaseUrl}/shoes/${SHOES_1_PRODUCT_NUMBER}.jpg`,
        width: imageWidth,
        height: 155
      }
    }
  ]
}

export const mockPitcherModel = (t: I18NText): Model[] => [
  {
    productNumber: AKG_1_PRODUCT_NUMBER,
    position: 'pitcher',
    imageUrl: `${imageBaseUrl}/akg-1.jpg`,
    dominantArm: 'both',
    size: t.AKG_1.size,
    webParts: 'w1',
    description: t.AKG_1.description,
    series: '',
    isFingerCrotch: false,
    isUBack: false,
    softPrice: softGloveBasePrice,
    price: t.BASE_PRICE_GLOVE,
    brand: 'atoms',
    imageWidth,
    imageHeight: 150
  }
]
